import useLockOffers from '@hooks/queries/registry/lock/useLockOffers';
import useLockRequests from '@hooks/queries/registry/lock/useLockRequests';
import useHolderService from '@hooks/queries/registry/onboarding/useHolderService';
import { useParties } from '../../contexts/PartiesContext';

export const useInboundLockRequests = () => {
  const holderService = useHolderService();
  const isHolder = !!holderService.data;

  const { party } = useParties();
  const locks = useLockOffers();
  const lockRequests = useLockRequests();
  const filteredRequests = lockRequests.data?.filter((l) => l.payload.lock.locker === party) || [];
  const filtered = locks.data?.filter((lock) => lock.payload.lock.locker === party) || [];
  if (!isHolder) {
    return [];
  }
  return [...filtered, ...filteredRequests];
};
